import { render, staticRenderFns } from "./wangeditor.vue?vue&type=template&id=55290f86&scoped=true"
import script from "./wangeditor.vue?vue&type=script&lang=js"
export * from "./wangeditor.vue?vue&type=script&lang=js"
import style0 from "./wangeditor.vue?vue&type=style&index=0&id=55290f86&prod&lang=scss&scoped=true"
import style1 from "./wangeditor.vue?vue&type=style&index=1&id=55290f86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55290f86",
  null
  
)

export default component.exports